module.exports = __webpack_public_path__ + "static/media/capri-sonne.5b68671a.svg";